export default __webpack_public_path__ + "static/media/jm.dce01b50.png";